export default __webpack_public_path__ + "static/media/telegram.efa4c981.png";